/*
export default {
    MAX_RESULTS: parseInt(500),
    APP_STAGE :"dev",
    APP_STAGE_NAME : "Sandbox 2",
    APP_STAGE_LEGACY_URL : "legacy-sandbox2ui.eidr.org",
    MATOMO_URL: "analytics.eidr.org",
    MATOMO_SITE_ID: 1,
    EIDR_LINKEDIN_URL: "https://www.linkedin.com/company/eidr/",
    EIDR_TWITTER_URL: "https://twitter.com/eidrdotorg?lang=en",

}
 */

export default {
    MAX_RESULTS: 500,
    APP_STAGE :process.env.NEXT_PUBLIC_APP_STAGE,
    APP_STAGE_NAME : process.env.NEXT_PUBLIC_APP_STAGE_NAME,
    APP_STAGE_LEGACY_URL : process.env.NEXT_PUBLIC_APP_STAGE_LEGACY_URL,
    MATOMO_URL: process.env.NEXT_PUBLIC_MATOMO_URL,
    MATOMO_SITE_ID: process.env.NEXT_PUBLIC_MATOMO_SITE_ID,
    EIDR_LINKEDIN_URL: process.env.NEXT_PUBLIC_EIDR_LINKEDIN_URL || "https://www.linkedin.com/company/eidr/",
    EIDR_TWITTER_URL: process.env.NEXT_PUBLIC_EIDR_TWITTER_URL || "https://twitter.com/eidrdotorg?lang=en",
    AUTH_CREDENTIALS: process.env.NEXT_PUBLIC_AUTH_CREDENTIALS || "false"

}
